export enum CajaWorkType {
  FullTime = 'fulltime',
  PartTime = 'parttime',
  Contract = 'contract',
  Casual = 'casual',
}
